import { Injectable } from '@angular/core';
import { GlobalNotification } from './global-notifications.model';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { NotificationsService } from '../notifications/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalNotificationsService {
  private notifications = new BehaviorSubject<GlobalNotification[]>([]);

  constructor(private notificationsService: NotificationsService) {}

  getNotifications(): Observable<GlobalNotification[]> {
    return this.notifications.asObservable();
  }

  show(notification: GlobalNotification): void {
    const newNotification: GlobalNotification = {
      ...notification,
      id: notification.id.length > 0 ? notification.id : this.generateId(),
      isPersistent: notification.isPersistent || false,
      duration: notification.isPersistent ? undefined : notification.duration || 10000,
      animationState: 'start',
      created_at: notification.isPersistent ? notification.created_at || new Date().toISOString() : undefined,
      link: notification.link || ''
    };

    const currentNotifications = this.notifications.getValue();
    this.notifications.next([...currentNotifications, newNotification]);
  }

  /**
   * Aktualizuje stan animacji powiadomienia o podanym ID
   * @param id Identyfikator powiadomienia
   * @param state Nowy stan animacji ('start' lub 'end')
   */
  updateNotificationState(id: string, state: 'start' | 'end'): void {
    const currentNotifications = this.notifications.getValue();
    const notificationIndex = currentNotifications.findIndex(n => n.id === id);

    if (notificationIndex !== -1) {
      // Tworzymy nową tablicę z zaktualizowanym powiadomieniem
      const updatedNotifications = [...currentNotifications];
      updatedNotifications[notificationIndex] = {
        ...updatedNotifications[notificationIndex],
        animationState: state
      };

      this.notifications.next(updatedNotifications);
    }
  }

  remove(id: string, isPersistent = true): void {
    const currentNotifications = this.notifications.getValue();
    this.notifications.next(currentNotifications.filter(notification => notification.id !== id));
    if (isPersistent) {
      // console.log('try to remove ', id, ' persistent');
      this.notificationsService.markNotificationAsRead(id).pipe(take(1)).subscribe();
    } else {
      // console.log('do not try toremove ', id, ' not persistent');
    }
  }

  removeAll(): void {
    this.notifications.next([]);
    this.notificationsService.markAllNotificationsAsRead().pipe(take(1)).subscribe();
  }

  hideAll(): void {
    this.notifications.next([]);
  }

  private generateId(): string {
    return `notification-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  }
}
